import { render, staticRenderFns } from "./ListProviderComponent.vue?vue&type=template&id=0f813aa5&scoped=true&"
import script from "./ListProviderComponent.vue?vue&type=script&lang=js&"
export * from "./ListProviderComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListProviderComponent.vue?vue&type=style&index=0&id=0f813aa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f813aa5",
  null
  
)

export default component.exports